import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { AppService } from '../../core/services/app.service';

@Component({
    selector: 'app-export',
    template: ``,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExportComponent implements OnDestroy {
  private _destroySubscription: Subject<boolean> = new Subject();

  constructor(private _appService: AppService, private _route: ActivatedRoute) {

    const calculationUrlId = this._route.snapshot.params['urlId'];

    _appService.fetchCalculationByUrlIdWithReqNavProps(calculationUrlId)
      .pipe(takeUntil(this._destroySubscription))
      .subscribe(() => {
        this._appService.getExportCalculation(calculationUrlId)
          .pipe(
            takeUntil(this._destroySubscription),
            finalize(() => setTimeout(() => window.close(), 600))).subscribe();
      });

  }

  ngOnDestroy(): void {
    this._destroySubscription.next(undefined);
    this._destroySubscription.complete();
  }
}
